export default {"src":"/_next/static/media/gear.d65c6f3a.svg","height":20,"width":20};